import { BrowserSignals, postSiteReport } from './siteReport';

/** What a tracked email link adds to a page of our site: ``n.<id>`` (notification) or ``c.<id>`` (campaign). */
export const EMAIL_CLICK_PARAM = 'email_click';
export const EMAIL_CLICK_REF = /^[nc]\.[0-9a-f-]{36}$/;

export const emailClickService = {
  /** Someone signed in landed here from an email link, or someone used the page: the click was a person's. */
  async reportUse(ref: string, signals: BrowserSignals): Promise<void> {
    await postSiteReport(`/api/v1/email/clicks/${encodeURIComponent(ref)}/engaged`, signals);
  },
};
